import styled, { css } from 'styled-components';
import JourneyList from './component';

import { skinsGroupage } from 'modules/journey/card/styled/groupageBackground';

export default styled(JourneyList)`
  background-color: var(--grey700);
  padding: 24px 24px 8px 24px;
  min-height: 80px;

  .container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .journey {
    background-color: #fff;
    height: 36px;
    display: flex;
    align-items: center;
    color: var(--grey700);
    margin-right: 16px;
    margin-bottom: 16px;
    max-width: 345px;
    overflow: hidden;
  }

  .journey_id {
    background-color: var(--grey100);
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    color: var(--grey700);
    font-weight: bold;
  }

  .shipper {
    padding: 0 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .shippers_hidden {
    padding: 0 8px 0 0;
    color: var(--grey800);
  }

  .skin {
    width: 8px;
    height: 100%;
  }

  .actions-button {
    font-size: 12px;
    padding: 0;
    margin: 0;
    border: 0;
    background-color: white;
    height: 32px;
    width: 32px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    margin-right: 2px;
    svg {
      height: 16px;
      width: 16px;
    }
    &:hover {
      background-color: var(--primary300);
      svg {
        height: 16px;
        width: 16px;
        fill: var(--white);
      }
    }
    &[disabled] {
      opacity: 0.5;
    }
  }

  ${Object.keys(skinsGroupage).map(
    (skin) => css`
      .skin_${skin} {
        background-color: ${skinsGroupage[skin]};
      }
    `
  )}
`;
